import request from "@/utils/request";

export function getCards() {
  return request({
    url: "/fleet/stripe/cards",
    headers: {
      "portal-token": true
    }
  });
}

export function addCard(data, token = true) {
  return request({
    url: `/fleet/v2/stripe/bindCard`,
    method: "post",
    data,
    headers: {
      "portal-token": token
    }
  });
}

export function setDefaultCard(cardId) {
  return request({
    url: `/fleet/stripe/${cardId}/default`,
    method: "put",
    headers: {
      "portal-token": true
    }
  });
}

export function removeCard(cardId) {
  return request({
    url: `/fleet/stripe/${cardId}/remove`,
    method: "delete",
    headers: {
      "portal-token": true
    }
  });
}

export function subScriptionTral() {
  return request({
    url: "/fleet/register/set/subscription/trial",
    headers: {
      "portal-token": true
    }
  });
}